/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import restClient from '../../app/helpers/restClient';

const RESOURCE_ROOT_FACADE = '/checkout';
const RESOURCE_PAGE_FACADE = '/cart';
const RESOURCE_PAGE_ACTION = '/greetingcard';

const addGreetingCard = (wcEnv, jwtToken, orderItemId, greetingCardData, orderId) => {
    const env = wcEnv;
    env.rootUri = RESOURCE_ROOT_FACADE;
    let resourcePage = `${RESOURCE_PAGE_FACADE}/${orderItemId}${RESOURCE_PAGE_ACTION}`;
    if (orderId) {
        resourcePage = `${RESOURCE_PAGE_FACADE}/${orderId}${RESOURCE_PAGE_ACTION}/${orderItemId}`;
    }
    return restClient.postFacade(env, resourcePage, jwtToken, greetingCardData)
        .then((response) => response);
};

export default addGreetingCard;
